import React, { useEffect } from "react";
import { Topbar } from "../components/include/Topbar";
import { Sidebar } from "../components/include/Sidebar";
import { Footer } from "../components/include/Footer";
import { useDispatch, useSelector } from "react-redux";
import { verifyToken } from "../redux/actions/authActions";
import Loader from "../components/common/Loader";
import { isAuthenticated, isPermission, isRole } from "../redux/selectors/authSelector";
import { toastShow, toastMessage } from "../redux/selectors/toastSelector";
import { Navigate, useLocation } from "react-router-dom";
import Toast from "../components/common/Toast";
import ApprovalModal from "../components/ApprovalModal";

const PrivateRoute = ({ Component }) => {
  const dispatch = useDispatch();
  const auth = useSelector(isAuthenticated);
  const toast_show = useSelector(toastShow);
  const toast_msg = useSelector(toastMessage);
  const permissions = useSelector(isPermission);
  const role = useSelector(isRole);
  const location = useLocation();
  
  const is_verified = useSelector((state) => state.auth?.data?.user?.school_id?.is_school_verified);
  const school = useSelector((state) => {
    return state.auth?.data?.user?.school_id;
  });
  const is_profile_completed = useSelector((state) => state.auth?.data?.user?.is_profile_completed);
  const is_approved = useSelector((state) => state.auth?.data?.user?.is_approved);
  const createdBy = useSelector((state) => state.auth?.data?.user?.created_by);
  const roleType = useSelector((state) => state.auth?.data?.user?.role_type);
  
  useEffect(() => {
    const token = window.localStorage.getItem("authorizationToken");
    if (token && !auth) {
      dispatch(verifyToken());
    }
  }, [auth, dispatch]);

  if (!auth && window.localStorage.getItem("authorizationToken")) {
    return <Loader isClass="loader_fullscreen" />;
  }

  return auth ? (
    <div className="flex p-[30px]">
      <Sidebar is_verified={is_verified} data={school} />
      <Toast show={toast_show} message={toast_msg} />
      <div className={`flex-1 min-h-screen md:ml-[15rem] ml-[5rem]`}>
        {(roleType === "schoolsubadmin" && !is_verified && is_profile_completed) ||
        (role === "schooladmin" && !is_verified && is_profile_completed) ? (
          <ApprovalModal isVisible={true} data={school} />
        ) : null}
        <main className="flex-1">
          <Component />
        </main>
      </div>
    </div>
  ) : (
    <Navigate to="/" />
  );
};

export default PrivateRoute;